import { Platform, StatusBar } from 'react-native';
import * as NavigationBar from 'expo-navigation-bar';

/**
 * Re-applies fullscreen system UI preferences after modal/tutorial flows.
 * Some Android devices can restore status/navigation bars when overlays close.
 */
export async function enforceImmersiveMode(): Promise<void> {
  StatusBar.setHidden(true, 'fade');

  if (Platform.OS !== 'android') {
    return;
  }

  try {
    await NavigationBar.setVisibilityAsync('hidden');
    await NavigationBar.setBehaviorAsync('overlay-swipe');
  } catch {
    // Ignore platform/device-specific failures.
  }
}
